const MuiAlert = {
  root: {},
};

export default MuiAlert;
